import {
  Component,
  InputSignal,
  input,
  numberAttribute, InputSignalWithTransform
} from '@angular/core';
import { IconComponent } from '../icon/icon.component';

export type AvatarType = 'solid' | 'outlined' | 'logo'

@Component({
  selector: 'td-wb-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  imports: [IconComponent]
})
export class AvatarComponent {
  private static readonly DEFAULT_SIZE: number = 50;
  private static readonly EXTRA_SMALL_SIZE_THRESHOLD: number = 25;
  private static readonly LARGE_SIZE_THRESHOLD: number = 40;
  private static readonly EXTRA_LARGE_SIZE_THRESHOLD: number = 60;
  initials: InputSignal<string | undefined> =  input<string>();
  avatarType: InputSignal<AvatarType> =  input<AvatarType>('outlined');
  size: InputSignalWithTransform<number, unknown> =  input<number, unknown>(AvatarComponent.DEFAULT_SIZE, { transform: numberAttribute });

  hasInitials(): boolean {
    return this.initials() !== undefined;
  }

  isOutlined(): boolean {
    return this.avatarType() === 'outlined';
  }

  isLogo(): boolean {
    return this.avatarType() === 'logo';
  }

  isExtraLarge(): boolean {
    return this.size() >= AvatarComponent.EXTRA_LARGE_SIZE_THRESHOLD;
  }

  isSmall(): boolean {
    return this.size() > AvatarComponent.EXTRA_SMALL_SIZE_THRESHOLD && this.size() < AvatarComponent.LARGE_SIZE_THRESHOLD;
  }

  isExtraSmall(): boolean {
    return this.size() <= AvatarComponent.EXTRA_SMALL_SIZE_THRESHOLD;
  }

  getSize(): string {
    return isNaN(Number(this.size())) ? AvatarComponent.DEFAULT_SIZE + 'px' : this.size() + 'px';
  }
}
